
import { mapState, mapMutations, mapActions } from 'vuex'
import DefaultForm from '@pleinair/bigcolony-vue/components/_globals/forms/DefaultForm.vue'

export default {
  name: 'SigninForm',
  components: {
    DefaultForm
  },
  props: {
    provider: {
      type: String,
      default: 'olo',
      validator: (value) => {
        return ['olo', 'spendgo', 'punchh'].includes(value)
      }
    },
    forgotPlacement: {
      type: String,
      default: 'none',
      validator: (value) => {
        return ['none', 'below', 'onElement'].includes(value)
      }
    },
    forgotLanguage: {
      type: String,
      default: 'Forgot Password?',
    },
    signinLanguage: {
      type: String,
      default: 'Sign In'
    },
    appLayout: {
      type: Boolean,
      default: false,
    },
    onSuccess: {
      type: Function,
      default: () => { }
    },
    formData: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    ...mapState(['appState']),
    email() {
      let email = this.formData?.email ? this.formData.email : ""
      let start = 3
      let end = email.indexOf("@")
      if (end) {
        let arr = email.split('')
        for (let i = start; i < end; i++) {
          arr[i] = '*'
        }
        email = arr.join('')
      }

      return email
    }
  },
  data() {
    let fields = []
    // create email field element
    let email = {
      name: 'method',
      label: 'Email',
      type: 'radio',
      value: 'email'
    }

    // create email field element
    // let sms = {
    //   name: 'method',
    //   label: 'SMS',
    //   type: 'radio',
    //   value: 'sms'
    // }

    // populate the fields object
    fields = [email].concat(fields)

    return {
      fields,
      message: null,
      method: 'email',
    }
  },
  methods: {
    ...mapMutations(['setLoading', 'setErrors']),
    ...mapActions(['sendRequest', 'trackEvent']),
    async handleVerifyCodeSubmit() {
      this.setLoading(true)
      let data = this.formData
      if (this.appState && this.appState.cart_id) {
        data.cart_id = this.appState.cart_id
      } else if (this.cart) {
        data.cart_id = this.cart.id
      }
      data.method = this.method
      let config = {
        method: 'post',
        url: 'members/auth',
        headers: {
          verify: true
        },
        data
      }
      const response = await this.sendRequest(config)
      if (response.status === 'ok') {
        this.trackEvent({
          name: 'sign_in',
          windowObject: window
        });
        this.onSuccess(response.data)
      } else if (response.status === 'validate') {
        data.session = response?.data?.session
        this.onSuccess(data)
      } else {
        this.setErrors("Username or password is incorrect.")
      }
      this.setLoading(false)
    },
    cancelVerify () {
      this.$parent.verify = false
      this.$parent.form = true
    }
  }
}
